import { cn, createBEM } from "@/libs";
import { ComponentBase } from "@/types";
import { Button } from "antd-mobile";
import { useEffect, useState } from "react";
import { Icon } from "../Icon";
import { makePlatformOnClick } from "../utils";
import "./index.scss";
export interface InputBaseProps {
  icon?: JSX.Element;
  extra?: JSX.Element;
  label?: JSX.Element;
  placeholder?: string;
  theme?: "auth" | "default" | "plain" | "android";
  formater?: (value: string) => string;
}
export interface InputProps extends ComponentBase.InputComponent, InputBaseProps {
  type?: "text" | "digit" | "password" | "textarea" | "number" | "tel";
}
export interface AreaInputProps extends ComponentBase.InputComponent<HTMLTextAreaElement>, InputBaseProps {
  type?: "text" | "digit" | "password" | "textarea" | "number" | "tel";
}
export const Input = ({
  type = "text",
  icon,
  extra,
  label,
  theme = "default",
  className,
  autocomplete = "new-password",
  maxLength = 50,
  formater,
  ...rest
}: InputProps & AreaInputProps) => {
  const b = createBEM("i-input");
  const [isShowPassword, setIsShowPassword] = useState(false);
  let _type: "text" | "digit" | "password" | "textarea" | "number" | "tel" = type;
  let inputmode: "decimal" | "numeric" | undefined = undefined;
  if (_type === "number") {
    _type = "text";
    inputmode = "decimal";
    formater = (value: string) => {
      const _val = (value.replaceAll(/[^\d.]/g, "").match(/^\d+\.?\d*/g) || [""])[0];
      return _val;
    };
  }
  if (type === "digit") {
    _type = "tel";
    inputmode = "numeric";
    formater = (value: string) => {
      const _val = value.replaceAll(/[^\d]/g, "");
      return _val;
    };
  }
  const [localType, setLocalType] = useState(_type);

  // 华为鸿蒙手机一律使用 text 不使用 password， 因为部分机型可能会产生bug：无法弹出软键盘
  const onShowPasswordButtonClick = () => {
    if (isShowPassword) {
      setLocalType("password");
    } else {
      setLocalType("text");
    }
    setIsShowPassword(!isShowPassword);
  };
  const showPasswordButton = type === "password" && <Button fill="none" {...makePlatformOnClick<HTMLButtonElement>(e => {
    e.preventDefault();
    onShowPasswordButtonClick();
  })}>
      <Icon name={`psw-${isShowPassword ? "show" : "hide"}`} />
    </Button>;
  const [_value, setValue] = useState<string>(String(rest.value || ""));
  const _formater = (value: string): string => {
    return formater ? formater(value) : value;
  };
  useEffect(() => {
    if (String(rest.value || "") !== _value && typeof rest.onChange === "function") {
      setValue(String(rest.value || ""));
    }
  }, [rest.value]);
  const _input = type === "textarea" ? <>
        <textarea {...(rest as AreaInputProps)} value={_value} className={cn(b("content"))} onChange={e => {
      setValue(e.target.value);
      rest.onChange?.(e);
    }} />
        <span className={b("word-limit")}>
          {_value.length}/{maxLength}
        </span>
      </> : <input {...(rest as InputProps)} value={_value} type={localType} inputMode={inputmode} className={cn(b("content"))} autoComplete={autocomplete} maxLength={maxLength} onChange={e => {
    const value = _formater(e.target.value);
    e.target.value = value;
    setValue(value);
    rest.onChange?.(e);
  }} />;
  if (theme === "android") {
    <div className={cn(b([theme, type]), className)}>
      <div className={b("top")}>
        {icon}
        {label}
      </div>
      <div className={b("bottom")}>
        {_input}
        {showPasswordButton}
        {extra}
      </div>
    </div>;
  }
  return <div className={cn(b([theme, type]), className)} data-sentry-component="Input" data-sentry-source-file="index.tsx">
      {icon}
      {label}
      {_input}
      {showPasswordButton}
      {extra}
    </div>;
};